export function createCustomEvent(id, payload, context) {
	const { event } = payload

	if (typeof event !== 'function') {
		throw new Error("Missing custom event constructor. Please provide an 'event' function.")
	}

	const customEvent = event({ ...payload, id }, context)

	return {
		type: 'custom',
		id,
		destroy() {
			customEvent?.destroy?.()
		},
	}
}
